import { Icon } from '@y42/core/icon';
import { amazonS3Icon, azureBloblStorageIcon, googleCloudStorageIcon } from '@y42/icons';

export enum BucketType {
  GoogleCloudStorage = 'GoogleCloudStorage',
  AzureBlobStorage = 'AzureBlobStorage',
  AmazonS3Storage = 'AmazonS3Storage',
}

export const BucketTypeToLabel: Record<BucketType, string> = {
  [BucketType.GoogleCloudStorage]: 'Google Cloud Storage',
  [BucketType.AzureBlobStorage]: 'Azure Blob Storage',
  [BucketType.AmazonS3Storage]: 'Amazon S3 Storage',
};

export const BucketTypeToLogo: Record<BucketType, Icon> = {
  [BucketType.GoogleCloudStorage]: googleCloudStorageIcon,
  [BucketType.AzureBlobStorage]: azureBloblStorageIcon,
  [BucketType.AmazonS3Storage]: amazonS3Icon,
};
